import { IRigRateDetail } from '../../interfaces/irig-rate-detail';
import { Rig } from '../rig';
import { Scenario } from '../scenario';

export class RigRateDetailBase {
  RigRateDetailId: number;
  ScenarioId: number;
  RigId: number;
  Month: Date | null;
  Price: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Rig?: Rig;
  Scenario?: Scenario;

  constructor(item?: IRigRateDetail) {
    if (item) {

      this.RigRateDetailId = item.RigRateDetailId;
      this.ScenarioId = item.ScenarioId;
      this.RigId = item.RigId;
      this.Month = item.Month ? new Date(item.Month) : null;
      this.Price = item.Price;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Rig = new Rig(item.Rig);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}